module.exports = __webpack_public_path__ + "img/companyApplyen.b6564492.png";